import UIBanner from 'UIComponents/alert/UIBanner';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import H5 from 'UIComponents/elements/headings/H5';
import { OBSIDIAN, OLAF, LORAX, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { WEB_FONT_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultBanner = ({
  button,
  className,
  closeable,
  dataTestId,
  style = {},
  subtext,
  titleText
}) => {
  const bannerStyle = Object.assign({}, style, {
    color: OBSIDIAN,
    background: OLAF,
    minHeight: '72px',
    border: `1px solid ${CALYPSO_MEDIUM}`,
    borderRadius: '5px'
  });
  return /*#__PURE__*/_jsx(UIBanner, {
    className: className,
    closeable: closeable,
    "data-test-id": dataTestId,
    style: bannerStyle,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-y-3",
      wrap: "wrap",
      align: "center",
      style: {
        gap: '16px 0'
      },
      children: [/*#__PURE__*/_jsxs(UIBox, {
        basis: 250,
        grow: 100,
        className: "flex-wrap align-center",
        style: {
          gap: '8px 0'
        },
        children: [/*#__PURE__*/_jsxs(UIBox, {
          className: "m-right-4 align-center",
          style: {
            lineHeight: 1
          },
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-3",
            size: 24,
            name: "upgrade",
            color: LORAX,
            style: {
              marginTop: '1px'
            }
          }), /*#__PURE__*/_jsx(H5, {
            style: {
              fontWeight: WEB_FONT_BOLD_WEIGHT,
              lineHeight: 1
            },
            className: "m-bottom-0",
            children: titleText
          })]
        }), /*#__PURE__*/_jsx(UIBox, {
          children: subtext
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 110,
        className: "m-left-1",
        children: button
      })]
    })
  });
};
export default DefaultBanner;